import { api } from "@/lib/api";
import { type Schemas } from "@/types";
import { useQuery } from "react-query";

export default function ActiveCasesTabQuery() {
  const { data } = useQuery({
    queryKey: ["activeCasesTabStats"],
    queryFn: async () => {
      const response = await api.get<Schemas["ActiveCasesTabStats"]>(
        "/api/Reports/ActiveCasesTabStats",
      );
      return response.data;
    },
  });

  return {
    totalCount: data?.totalActiveCases,
    closedToday: data?.totalClosedToday,
  };
}
